import { render, staticRenderFns } from "./Tongji.vue?vue&type=template&id=15b8680c&scoped=true"
import script from "./Tongji.vue?vue&type=script&lang=js"
export * from "./Tongji.vue?vue&type=script&lang=js"
import style0 from "./Tongji.vue?vue&type=style&index=0&id=15b8680c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8680c",
  null
  
)

export default component.exports